import "./requestquote.scss"
import {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { validate, isPosting } from "../../utils/validate";
const FormData = require("form-data");
// import Button from "../../components/button/Button";

const RequestQuote = ()=> {
  const [inputs, setInputs] = useState({
    firstname: "",
    lastname: "",
    email:"",
    phone:"",
    quantity:"",
    message:"",
    "sample photo": ""
  })
  
  type FormErr = {
    [key: string]: string | number
  }
  const [image, setImage] = useState<File | null>();
  const [posting, setPosting] = useState(false);
  const [error, setError] = useState(null);
  const [formError, setFormError] = useState<FormErr>({})
  const [successInfo, setSuccessInfo] = useState("");

  const [open, setOpen] = useState(false);



  const navigate = useNavigate()

  const handleChange = (e: React.SyntheticEvent<EventTarget>)=>{
    setInputs({
      ...inputs, [(e.target as HTMLInputElement).name]: (e.target as HTMLInputElement).value
    })
  }

  const handleClick= (e: React.SyntheticEvent<EventTarget>) =>{
    e.preventDefault();
    (document.getElementById("sample") as HTMLInputElement).click()
  }

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputs({
      ...inputs, "sample photo": (document.getElementById("sample") as HTMLInputElement).value.replace(/^.*\\/, "")
    })
    setImage(e.target.files![0])
  }

  const submitRequest = (e: React.SyntheticEvent<EventTarget>) =>{
    e.preventDefault();
    setFormError(validate(inputs))
    if(isPosting(inputs)){
      setOpen(true);
      setPosting(true);
    }
    // console.log(isPosting(inputs));
 
    let formData = new FormData();
    if(inputs.firstname){formData.append("firstname", inputs.firstname)};
    if(inputs.lastname){formData.append("lastname", inputs.lastname)};
    if(inputs.email){formData.append("email", inputs.email)};
    if(inputs.phone){formData.append("phone", inputs.phone)};
    if(inputs.quantity){formData.append("quantity", inputs.quantity)};
    if(inputs.message){formData.append("message", inputs.message)};
    if(image){formData.append("sample", image); };

if(isPosting(inputs)){axios.post("https://gmapi.raydrongarmentsmanufacturing.com/api/v1/requestquote", formData)
  .then (res => {
    setPosting(false)
    setError(null);
    setSuccessInfo("Your request was successfully sent. Expect a feedback from us soon.");
    

    setInputs({
      firstname: "",
      lastname: "",
      email:"",
      phone:"",
      quantity:"",
      message:"",
      "sample photo": ""
    });
  
    setImage(null);
})
  .catch((err)=>{
    setPosting(false);
    setSuccessInfo("");
    setError(err.response.data.message);
  })}
}

  //  console.log(inputs)

  const closeModal =()=>{
    setOpen(false);
    setPosting(false);
    navigate("/products");
  }

  
  return (
    <>
    <div className="quote">
        <p className="quote__text">
        Dear Customer, 
        Please tell us more about your design and any special specifications it may have. We will work together with you to deliver high end products.
        </p>
        <div className="quoteform"><form  encType="multipart/form-data" onSubmit={submitRequest}>
          <div className="label"><label htmlFor="firstname">First Name:</label>
          <input className="form__input" type ="text" placeholder="First Name" id="firstname" name="firstname" onChange={handleChange} value={inputs.firstname} />
            <p className="formError">{formError.firstname}</p>
          </div>

          <div className="label"><label htmlFor="lastname">Last Name:</label>
          <input className="form__input" type ="text" placeholder="Last Name" id="lasttname" name="lastname" onChange={handleChange}  value={inputs.lastname} />
            <p className="formError">{formError.lastname}</p>
          </div>

          <div className="label"><label htmlFor="email">Email Address:</label>
          <input className="form__input" type ="text" placeholder="email@example.com" id="email" name="email" onChange={handleChange} value={inputs.email}  />
          <p className="formError">{formError.email}</p>
          </div>

          <div className="label"><label htmlFor="phone">Phone:</label>
          <input className="form__input" type ="text" placeholder="08100767442" id="phone" name="phone" onChange={handleChange} value={inputs.phone}  />
            <p className="formError">{formError.phone}</p>
          </div>
          <div className="label"><label htmlFor="qty">Quantity:</label>
          <input  className="form__input" type ="text" placeholder="100" id="qty" name="quantity" onChange={handleChange} value={inputs.quantity}  />
              <p className="formError">{formError.quantity}</p>
          </div>
          <div className="label"><label htmlFor="sample" className="file__upload"><button className="btnRed" onClick={handleClick}>Upload a Sample Picture</button></label><input className="file__input"  type ="file" id="sample" onChange={handleFile} name="file" accept='image/png, image/jpeg' /><span className="filename">{inputs["sample photo"]}</span>
            <p className="formError">{formError["sample photo"]}</p>
          </div>
          
          <div className="label"><label htmlFor="details">Additional Details:</label>
          <textarea className="text__input" rows={4} onChange={handleChange} id="details" name="message" placeholder="Tell us your specifications" value={inputs.message} ></textarea>
              <p className="formError">{formError.message}</p>
          </div>

          <div className={error? "error" : "success"}>
            {error}
          </div>

          <div className="quotebtn"><input type="submit" className="btnGold"/></div>
        </form>
        </div>
    </div>
    {open && posting?
            <div className="overlay">
            <div className="modal">
                <div className="spinning"><FontAwesomeIcon icon={faSpinner} className="spinner fa-spin"/></div>
                <div className="sending">Sending your request</div>
            </div>
          </div>
    : open && !posting && <div className="overlay" onClick={closeModal}>
      <div className="modal">
        <div className="icon__modal" onClick={closeModal}>
          <FontAwesomeIcon icon={faTimes}/>
        </div>
          <div className="sent">{successInfo}</div>
          {/* <div className="redirect">{redirectMsg}</div> */}
      </div>
    </div> }
    </>
  )
}

export default RequestQuote;